import snakeCase from "lodash/snakeCase";

const SIZE_FORMATS = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

export function formatNumberFraction(number, scale = 2) {
  return Number(parseFloat(number).toFixed(number % 1 === 0 ? 0 : scale));
}
export function formattedFileSize(bytes, roundValue = false) {
  if (bytes === 0) return "0 Bytes";

  // TODO - Replace 1000 with 1024 here
  // * This is temporary fix
  const divideFactor = bytes % 1000 === 0 ? 1000 : 1024;

  const sizeIndex = Math.floor(Math.log(bytes) / Math.log(divideFactor));
  const value = formatNumberFraction(bytes / divideFactor ** sizeIndex);
  const roundedValue = Math.round(formatNumberFraction(bytes / divideFactor ** sizeIndex));
  const returnValue = roundValue ? roundedValue : value;
  return `${returnValue} ${SIZE_FORMATS[sizeIndex]}`;
}

export const getAttachmentNameFromHeaders = (contentDisposition = "", fallbackName = "") => {
  if (!contentDisposition) return fallbackName;
  const fileNamePart = contentDisposition
    .split(";")
    .map((part) => part.trim())
    .find((part) => part.toLowerCase().startsWith("filename="));
  return fileNamePart
    ? fileNamePart.split("=").slice(1).join("=").trim().replace(/^"|"$/g, "")
    : fallbackName;
};

export const convertFileToUrl = (file) => {
  return URL.createObjectURL(file);
};

export const appendObjectInFormData = ({
  obj = {},
  parentKey = "",
  data,
  snakifyKeys = true,
  transformNullValue = false,
}) => {
  Object.entries(obj).forEach(([key, value]) => {
    const isValueObj = Boolean(value && typeof value === "object");
    const isIteratingArray = Array.isArray(obj);
    const keyName = snakifyKeys && !key?.startsWith("_") ? snakeCase(key) : key;
    const propName = isIteratingArray ? "" : keyName;
    const isAttachment = [File, Blob].includes(value?.constructor);

    const newKey = `${parentKey}[${propName}]${isAttachment ? "[attachment]" : ""}`;
    if (!isAttachment && isValueObj && !isIteratingArray) {
      return appendObjectInFormData({
        parentKey: newKey,
        obj: value,
        data,
        snakifyKeys,
      });
    }
    const newValue = (() => {
      if (isIteratingArray) {
        return JSON.stringify(value);
      }
      if (value === null && transformNullValue) {
        return undefined;
      }
      return value;
    })();
    if (typeof newValue !== "undefined") {
      data.append(newKey, newValue);
    }
  });
};
